import { render, staticRenderFns } from "./IconTextButton_outline.vue?vue&type=template&id=b4342068&scoped=true"
import script from "./IconTextButton_outline.vue?vue&type=script&lang=js"
export * from "./IconTextButton_outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4342068",
  null
  
)

export default component.exports